import { render, staticRenderFns } from "./startUpClasses.vue?vue&type=template&id=42a33e02&scoped=true"
import script from "./startUpClasses.vue?vue&type=script&lang=js"
export * from "./startUpClasses.vue?vue&type=script&lang=js"
import style0 from "./startUpClasses.vue?vue&type=style&index=0&id=42a33e02&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a33e02",
  null
  
)

export default component.exports